import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import styled from "styled-components";
import { Alert } from "react-bootstrap";
import {
  getAboutUsTeam,
  getAboutUsTeamParagraph,
  deleteMeetTheTeam,
} from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import CustomTable from "../../Common/DataTable/DataTable";

export default function MeetTeamView() {
  const {id,partnerId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [temParagraph, setParagraph] = useState([{}]);
  const [showSuccessMessage1, setShowSuccessMessage1] = useState(false);
  const [teamId, setTeamId] = useState("");


  useEffect(() => {
    setIsLoading(true);
    if (!Number(partnerId)) {
      setIsLoading(false);
      return
    };

    const fetchData = async () => {
      try {
        const result = await getAboutUsTeam(partnerId);
        const meetTeamData = result.data.data
        
        if (meetTeamData?.length) {
          setData(meetTeamData);
        }
        
        const paragraphResult = await getAboutUsTeamParagraph(id);
        const paragraphData = paragraphResult.data.data[0];
        setParagraph({...paragraphData,...paragraphData,index:paragraphResult.data.data.indexOf(paragraphData)})
        console.log(paragraphResult.data.data[0]);
      } catch (error) {
        console.error(error);
      }finally{
        setIsLoading(false);
      }
    };
    fetchData();
  }, [partnerId]);

  const handleDelete = (id) => {
    setTeamId(id);
    setShowSuccessMessage1(true);
  };
  
    const confirmDelete = async () => {
      try {
        const response = await deleteMeetTheTeam(teamId);
        if (response.status === 200) {
          showToast({
            type: 'success',
            message: response?.data?.message || "Team slider section has been deleted successfully!",
          });
          window.location.reload();
        } else {
          showToast({
            type: 'error',
            message: response?.data?.message || "Failed to delete team slider section. Please try again.",
          });
        }
      } catch (error) {
        showToast({
          type: 'error',
          message: error?.response?.data?.message || "Failed to delete team slider section. Please try again.",
        });
      }
  };

  const columns = ["Part Name", "Content"];
  const rows = [];

  if (temParagraph && Object.keys(temParagraph).length > 0 && temParagraph.index !== -1) {
    rows.push(['Paragraph 1', temParagraph.paragraph]);
  }
 
  const columnsNew = ["pet", "image", "owner", "position", "functions"];
  const rowsNew = [];
 
  if(Array.isArray(data) && data.length > 0) {
  const item = data[0];
  rowsNew.push([
    item.name,
    item.image ? <img src={item.image} alt="image" height="auto" width="300px" /> : null,
    item.owner,
    item.position,
    (
      <div className="d-flex" style={{justifyContent: "center",gap:'10px'}}>
        <Link to={`/${partnerId}/aboutus/meet_the_team/edit/${item.id}`}>
          <Button className="w-auto m-0">Edit</Button>
        </Link>
        <Button
        className="w-auto m-0"
          onClick={() => {
            handleDelete(item.id);
          }}
          style={{ backgroundColor: "#dc3545", border: "red" }}
        >
          Delete
        </Button>
      </div>
    )
  ]);
  }
  
  return (
    <>
    {isLoading ? <CmsCircularProgress/> : 
    <ContentWrapper>
      <HomeTitle>Meet the Team Section</HomeTitle>
      <TableWrapper>
        <SubTitle>Paragraph section</SubTitle>    
       <TableSection>
       <CustomTable columns={columns} rows={rows}/>
       </TableSection> 
        <ButtonWrapper>
          <Link
            to={`/${partnerId}/aboutus`}
          >
            <Button variant="secondary">Go Back</Button>
          </Link>
          <Link
            to={`/${partnerId}/aboutus/meet_the_team/paragraph/edit/${id}`}
          >
            <Button>{Number(id) ? 'Edit' : 'Add'} Paragraph section</Button>
          </Link>
        </ButtonWrapper>
       
        <HeaderSection>
          <SubTitle>Team slider section</SubTitle>
          <Link to={`/${partnerId}/aboutus/meet_the_team/create/${Number(id) ? id : temParagraph?.id}`}>
            <Button style={{ width: "150px" }}>Create a New</Button>
          </Link>
        </HeaderSection>
        <CustomTable columns={columnsNew} rows={rowsNew}/>
      </TableWrapper>
      {showSuccessMessage1 && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 100,
            }}
          ></div>
          <Alert
            variant="danger"
            dismissible={false}
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              maxWidth: '456px',
              width: 'calc(100vw - 8vw)',
              height: "auto",
              zIndex: 1000,
            }}
          >
            <Alert.Heading
              style={{
                fontSize: "1.5rem",
                color: "#842029",
                textAlign: "center",
              }}
            >
              Confirm Delete
            </Alert.Heading>
            <p style={{ textAlign: "center", color: "#842029" }}>
              Are you sure you want to delete this Item?
            </p>
            <div
              className="d-flex justify-content-end"
              style={{ display: "grid", gridGap: "10px" }}
            >
              <Button
                style={{ color: "white" }}
                className="btn btn-danger mb-3 mr-2"
                onClick={() => { 
                  confirmDelete();
                  setShowSuccessMessage1(false);
                }}
              >
                Yes
              </Button>
              <Button
                className="btn btn-secondary mb-3"
                onClick={() => {
                  setShowSuccessMessage1(false);
                }}
              >
                No
              </Button>
            </div>
          </Alert>
        </>
      )}
    </ContentWrapper>}
    </>
  );
}

const ContentWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const SubTitle = styled.h4`
  text-align: center;
`;

const TableWrapper = styled.div`
  margin: 0 auto;
  // overflow-x: auto;
`;
const TableSection = styled.div`
  margin: 0 auto;
  overflow-x: auto;
`;


const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 2rem;
  justify-content: center;
  @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
}
`;
const HeaderSection = styled.div`
  text-align: center;
`;
